<div id="content" class="allcp-form" ng-controller="UserController" ng-init="show()">
    <div ng-include="'modules/company/menus/user_menu.html'"></div>
    <div class="panel-body">
        <form ng-submit="updateUser()" class="form-horizontal">
            <div class="col-md-8">
                <h5>Yetkili Detayları</h5>
                <hr>
                <div class="form-group row">
                    <label class="col-md-3 control-label">Adı : </label>
                    <div class="col-md-9">
                        <label for="name21" class="field prepend-icon">
                            <input type="text" ng-model="user.first_name" class="event-name gui-input br-light light" placeholder="Adı" required>
                            <label for="name21" class="field-icon">
                                <i class="fa fa-user"></i>
                            </label>
                        </label>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-3 control-label">Soyadı : </label>
                    <div class="col-md-9">
                        <label for="name21" class="field prepend-icon">
                            <input type="text" ng-model="user.last_name" class="event-name gui-input br-light light"
                                   placeholder="Soyadı" required>
                            <label for="name21" class="field-icon">
                                <i class="fa fa-user"></i>
                            </label>
                        </label>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-3 control-label">Mail Adresi : </label>
                    <div class="col-md-9">
                        <label for="name21" class="field prepend-icon">
                            <input type="email" ng-model="user.email" class="event-name gui-input br-light light"
                                   placeholder="E-Mail" required>
                            <label for="name21" class="field-icon">
                                <i class="fa fa-envelope"></i>
                            </label>
                        </label>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-3 control-label">Şifre : </label>
                    <div class="col-md-9">
                        <label for="name21" class="field prepend-icon">
                            <input type="password" ng-model="user.password" class="event-name gui-input br-light light"
                                   placeholder="******">
                            <label for="name21" class="field-icon">
                                <i class="fa fa-lock"></i>
                            </label>
                        </label>
                    </div>
                </div>
                <!--
                <div class="form-group row">
                    <label class="col-md-3 control-label">Ekip : </label>
                    <div class="col-md-9">
                        <label for="name21" class="field">
                            <ui-select multiple tagging ng-model="user.teams" title="Ekip">
                                <ui-select-match placeholder="Ekip Seçiniz...">{{ $item.name }}</ui-select-match>
                                <ui-select-choices repeat="item as item in data.teams | filter: $select.search">
                                    <div class="row mr10 ml10">
                                        <span ng-bind="item.name"></span>
                                    </div>
                                </ui-select-choices>
                            </ui-select>
                        </label>
                    </div>
                </div>
                -->
                <hr>
                <div class="form-group row">
                    <label class="col-md-3 control-label">İzinler </label>
                    <div class="col-md-9">

                        <div class="checkbox-custom mt10">
                            <input type="checkbox"
                                   ng-model="user.authorization.maps"
                                   ng-checked="user.authorization.maps"
                                   ng-disabled="user.owner"
                                   id="maps">
                            <label for="maps">Saha Yönetimi</label>
                        </div>
                        <div class="checkbox-custom mt10">
                            <input type="checkbox"
                                   ng-model="user.authorization.office"
                                   ng-checked="user.authorization.office"
                                   ng-disabled="user.owner"
                                   id="office">
                            <label for="office">Ofis Yönetimi</label>
                        </div>
                        <div class="checkbox-custom mt10">
                            <input type="checkbox"
                                   ng-model="user.authorization.customers"
                                   ng-checked="user.authorization.customers"
                                   ng-disabled="user.owner"
                                   id="customers">
                            <label for="customers">Müşteri Yönetimi</label>
                        </div>
                        <div class="checkbox-custom mt10">
                            <input type="checkbox"
                                   ng-model="user.authorization.users"
                                   ng-checked="user.authorization.users"
                                   ng-disabled="user.owner"
                                   id="users">
                            <label for="users">Kullanıcı Yönetimi</label>
                        </div>
                        <div class="checkbox-custom mt10">
                            <input type="checkbox"
                                   ng-model="user.authorization.reports"
                                   ng-checked="user.authorization.reports"
                                   ng-disabled="user.owner"
                                   id="reports">
                            <label for="reports">Rapor Yönetimi</label>
                        </div>
                        <div class="checkbox-custom mt10">
                            <input type="checkbox"
                                   ng-model="user.authorization.settings"
                                   ng-checked="user.authorization.settings"
                                   ng-disabled="user.owner"
                                   id="settings">
                            <label for="settings">Ayar Yönetimi</label>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-3 control-label"></label>
                    <div class="col-md-9">
                        <button type="submit" class="btn btn-success pull-right"><span class="fa fa-edit"></span>
                            Güncelle</a>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
